import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Divider,
    Tooltip
} from '@mui/material';
import WorkspaceOwnerIcon from '@mui/icons-material/Token';
import WorkspaceAdminIcon from '@mui/icons-material/BrightnessAuto';
import WorkspaceWorkerIcon from '@mui/icons-material/Person';
import {useTranslation} from "react-i18next";
import '../../css/components/Profile/PlatformInformation.css';

const PlatformInformation = ({ userStatData }) => {
    const { t } = useTranslation();

    return (
        <Card className="platform-info-card">
            <CardContent>
                <Typography variant="h6" color="primary" gutterBottom>{t("profile.platform_info")}</Typography>
                <Divider className="platform-info-divider" />
                {userStatData && userStatData.workspace_roles.map(([workspace, role]) => (
                    <div key={workspace}>
                        <Typography variant="body1" className="platform-info-text" component="div">
                            <strong>{t("profile.workspace")}</strong>
                            <Typography component="span">
                                {workspace}
                                <Tooltip title={role === 'Owner' ? t("profile.workspace_owner") : role === 'Admin' ? t("profile.workspace_admin") : t("profile.workspace_worker")}>
                                    {role === 'Owner' ? (
                                        <WorkspaceOwnerIcon className="platform-info-workspace-icon" />
                                    ) : role === 'Admin' ? (
                                        <WorkspaceAdminIcon className="platform-info-workspace-icon" />
                                    ) : (
                                        <WorkspaceWorkerIcon className="platform-info-workspace-icon" />
                                    )}
                                </Tooltip>
                            </Typography>
                        </Typography>

                        {role === "Owner" && userStatData.projects.owned[workspace] !== 0 &&
                            <Typography variant="body2" className="platform-info-project-text">
                                {t("profile.project_owner", {count: userStatData.projects.owned[workspace]})}
                            </Typography>
                        }
                        {role === "Worker" && userStatData.projects.worker[workspace] !== 0 &&
                            <Typography variant="body2" className="platform-info-project-text">
                                {t("profile.project_worker", {count: userStatData.projects.worker[workspace]})}
                            </Typography>
                        }
                    </div>
                ))}
            </CardContent>
        </Card>
    );
};

export default PlatformInformation;
